import { useRequest } from 'ahooks'
import { Cascader, CascaderProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const IndustrySelect: React.FC<Omit<CascaderProps<any>, 'options'>> = React.forwardRef((props, ref) => {
  const { i18n } = useTranslation()
  const { data } = useRequest(
    {
      url: '/api/project/getIndustries',
    },
    {
      cacheKey: 'industries',
      cacheTime: -1,
      staleTime: -1,
      refreshOnWindowFocus: false,
    }
  )

  const options = (data || []).map((d: any) => ({
    label: i18n.resolvedLanguage === 'zh' ? d.name : d.ename,
    value: d.id,
    children: d.scenarios.map((s: any) => ({
      label: i18n.resolvedLanguage === 'zh' ? s.name : s.ename,
      value: s.id,
      industryId: s.industryId,
    })),
  }))

  return <Cascader ref={ref as any} allowClear placeholder='' options={options} {...(props as any)} />
})
